import React, { useMemo } from 'react';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
const ToolTipContent = ({ subtitle, onPress, learnMore, btnText = 'OK', extraBtnText, onExtraBtnPress, onPressLearnMore, }) => {
    const subTitleNode = useMemo(() => {
        if (Array.isArray(subtitle)) {
            return (<>
          {subtitle.map((paragraph, index) => (<React.Fragment key={index}>
              {index > 0 && <Spacer h={10}/>}
              <Text TextThin-14 Gray centered>
                {paragraph}
              </Text>
            </React.Fragment>))}
        </>);
        }
        if (React.isValidElement(subtitle))
            return subtitle;
        if (typeof subtitle === 'string' || learnMore) {
            return (<Text TextThin-14 Gray centered>
          {typeof subtitle === 'string' ? `${subtitle} ` : ''}
          {learnMore ? (<Text Text-14 Primary suppressHighlighting onPress={onPressLearnMore}>
              Learn more
            </Text>) : null}
        </Text>);
        }
        return null;
    }, [learnMore, onPressLearnMore, subtitle]);
    return (<>
      <Spacer h={16}/>
      {subTitleNode}

      <Spacer h={24}/>
      {!!extraBtnText && onExtraBtnPress ? (<>
          <Button brandReversed title={extraBtnText} onPress={onExtraBtnPress}/>
          <Spacer h={8}/>
        </>) : null}
      <Button brand title={btnText} onPress={onPress}/>
    </>);
};
export default ToolTipContent;
